import dynamic from "next/dynamic";
import PollWorldCup from "./Mundial/Templates/PollWorldCup";
import HeaderWorldCup from "./Misc/Templates/HeaderWorldCup";
import EnergiaYMineria from "./Misc/Templates/EnergiaYMineria";

const templates = {
  //banner
  Banner: dynamic(() => import("./Banner/Templates/Banner")),
  BannerLazy: dynamic(() => import("./Banner/Templates/BannerLazy")),
  BannerHorizontal: dynamic(() =>
    import("./Banner/Templates/BannerHorizontal")
  ),
  SponsorRural: dynamic(() => import("./Banner/Templates/SponsorRural")),
  //misc
  SubscriptionButton: dynamic(() => import("./Misc/Templates/SubscriptionButton")),
  Freehtml: dynamic(() => import("./Misc/Templates/Freehtml")),
  RichText: dynamic(() => import('./Misc/Templates/RichText')),
  ContainerHTMLLibre: dynamic(() =>
    import("./Misc/Templates/ContainerHTMLLibre")
  ),
  Argenprop: dynamic(() => import("./Misc/Templates/Argenprop")),
  CtaSeccionTasador: dynamic(() => import("./Misc/Templates/CtaModuloTasador")),
  PriceRural: dynamic(() => import("./Misc/Templates/PriceRural")),
  ScriptLibre: dynamic(() => import("./Misc/Templates/ScriptLibre")),
  Streaming: dynamic(() => import("./Misc/Templates/Streaming")),
  Title: dynamic(() => import("./Misc/Templates/Title")),
  WeatherRural: dynamic(() => import("./Misc/Templates/WeatherRural")),
  WorldCupDraw: dynamic(() => import("./Misc/Templates/WorldCupDraw")),
  EnergiaYMineria: dynamic(() => import("./Misc/Templates/EnergiaYMineria")),
  LatestRigthColumn: dynamic(() =>
    import("./Misc/Templates/LatestRightColumn")
  ),
  LatestVideoRigthColumn: dynamic(() =>
    import("./Misc/Templates/LatestVideoRigthColumn")
  ),
  MostSeenSuscription: dynamic(() =>
    import("./Misc/Templates/MostSeenSuscription")
  ),
  Games: dynamic(() => import("./Misc/Templates/Games")),
  ContainerJokes: dynamic(() => import("./Misc/Templates/ContainerJokes")),
  Countdown: dynamic(() => import("./Misc/Templates/Countdown")),
  MAMTicker: dynamic(() => import("./Misc/Templates/MAMTicker")),
  ClubWorldCup: dynamic(() => import("./Misc/Templates/ClubWorldCup")),
  SeparatorRecipes: dynamic(() => import("./Misc/Templates/SeparatorRecipes")),
  SeparatorWithLinks: dynamic(() => import("./Misc/Templates/SeparatorWithLinks")),
  RecipesIA: dynamic(() => import("./Misc/Templates/RecipesIA")),
  Elections: dynamic(() => import("./Misc/Templates/Elections")),
  AgendaDeportiva: dynamic(() => import('./Misc/Templates/AgendaDeportiva')),
  SliderJWP: dynamic(() => import('./Misc/Templates/SliderJWP')),


  //Mundial
  VestHistory: dynamic(() => import('./Mundial/Templates/VestHistory')),
  VenuesAndMatches: dynamic(() => import('./Mundial/Templates/VenuesAndMatches')),
  MAMWorldCup: dynamic(() => import('./Mundial/Templates/MAMWorldCup')),
  TeamJourney: dynamic(() => import('./Mundial/Templates/TeamJourney')),
  CamisetaIA: dynamic(() => import('./Mundial/Templates/CamisetaIA')),
  Bracket: dynamic(() => import('./Mundial/Templates/Bracket')),
  PollWorldCup: dynamic(() => import('./Mundial/Templates/PollWorldCup')),
  Moments: dynamic(() => import('./Mundial/Templates/Moments')),
  HeaderWorldCup: dynamic(() => import('./Mundial/Templates/HeaderWorldCup')),
  TriviaWorldCup: dynamic(() => import('./Mundial/Templates/TriviaWorldCup')),
  LinkTriviaWorldCup: dynamic(() => import('./Mundial/Templates/LinkTriviaWorldCup')),
  LinkGuideWorldCup: dynamic(() => import('./Mundial/Templates/LinkGuideWorldCup')),
  AgendaDeportivaWorldCup: dynamic(() => import('./Mundial/Templates/AgendaDeportivaWorldCup')),
  PositionsTable: dynamic(() => import('./Mundial/Templates/PositionsTable')),
  HeaderWorldCup: dynamic(() => import('./Misc/Templates/HeaderWorldCup')),
  LinkTeamWorldCup: dynamic(() => import('./Mundial/Templates/LinkTeamWorldCup')),
  LinkFixtureWorldCup: dynamic(() => import('./Mundial/Templates/LinkFixtureWorldCup')),
  GroupStages: dynamic(() => import('./Mundial/Templates/GroupStages')),
  
  //modulos
  MostViewed: dynamic(() => import("./Listado/Templates/MostViewed")),
  ListBuckets: dynamic(() => import("./Listado/Templates/ListBuckets")),
  RevistaElle: dynamic(() => import("./Listado/Templates/RevistaElle")),
  //Containers
  Container1Piso4: dynamic(() =>
    import("./Container/Templates/Container1Piso4")
  ),
  Container1Piso3Apertura: dynamic(() =>
    import("./Container/Templates/Container1Piso3Apertura")
  ),
  Container1Piso3Recipes: dynamic(() =>
    import("./Container/Templates/Container1Piso3Recipes")
  ),
  Container1PisoA: dynamic(() =>
    import("./Container/Templates/Container1PisoA")
  ),
  Container1PisoList: dynamic(() =>
    import("./Container/Templates/Container1PisoList")
  ),
  Container1PisoB: dynamic(() =>
    import("./Container/Templates/Container1PisoB")
  ),
  Container1PisoBN: dynamic(() => 
    import('./Container/Templates/Container1PisoBN')
  ),
  Container1PisoColumnas: dynamic(() =>
    import("./Container/Templates/Container1PisoColumnas")
  ),
  Container1PisoCuadrado: dynamic(() =>
    import("./Container/Templates/Container1PisoCuadrado")
  ),
  Container2PisosCuadrado: dynamic(() =>
    import("./Container/Templates/Container2PisosCuadrado")
  ),
  Container2Pisos: dynamic(() =>
    import("./Container/Templates/Container2Pisos")
  ),
  Container2PisosB: dynamic(() =>
    import("./Container/Templates/Container2PisosB")
  ),
  Container2PisosC: dynamic(() =>
    import("./Container/Templates/Container2PisosC")
  ),
  Container2PisosExtra: dynamic(() =>
    import("./Container/Templates/Container2PisosExtra")
  ),
  Container2PisosExtraFlip: dynamic(() =>
    import("./Container/Templates/Container2PisosExtraFlip")
  ),
  Container2PisosExtraList: dynamic(() =>
    import("./Container/Templates/Container2PisosExtraList")
  ),
  Container2PisosSpecial: dynamic(() =>
    import("./Container/Templates/Container2PisosSpecial")
  ),
  Container3PisosB: dynamic(() =>
    import("./Container/Templates/Container3PisosB")
  ),
  Container3PisosC: dynamic(() =>
    import("./Container/Templates/Container3PisosC")
  ),
    Container3PisosD: dynamic(() =>
    import("./Container/Templates/Container3PisosD")
  ),
  Container3Pisos: dynamic(() =>
    import("./Container/Templates/Container3Pisos")
  ),
  Container4Pisos: dynamic(() =>
    import("./Container/Templates/Container4Pisos")
  ),
  Container5Pisos: dynamic(() =>
    import("./Container/Templates/Container5Pisos")
  ),
  Container5PisosExtra: dynamic(() => import('./Container/Templates/Container5PisosExtra')),
  Container5PisosVideo: dynamic(() => import('./Container/Templates/Container5PisosVideo')),
  Container6Pisos: dynamic(() =>
    import("./Container/Templates/Container6Pisos")
  ),
  Container7Pisos: dynamic(() =>
    import("./Container/Templates/Container7Pisos")
  ),
  Container7PisosVideo: dynamic(() =>
    import("./Container/Templates/Container7PisosVideo")
  ),
  ContainerBrandStudio: dynamic(() =>
    import("./Container/Templates/ContainerBrandStudio")
  ),
  ContainerExclusivo: dynamic(() =>
    import("./Container/Templates/ContainerExclusivo")
  ),
  ContainerFama: dynamic(() => import("./Container/Templates/ContainerFama")),
  ContainerMultimedia: dynamic(() => import('./Container/Templates/ContainerMultimedia')),
  ModuloApertura: dynamic(() => import("./Container/Templates/ModuloApertura")),
  ContainerExclusivoDomingo: dynamic(() =>
    import("./Container/Templates/ContainerExclusivoDomingo")
  ),
  ContainerAperturaRecipes: dynamic(() =>
    import("./Container/Templates/ContainerAperturaRecipes")
  ),
  Container2PisosBRecipes: dynamic(() =>
    import("./Container/Templates/Container2PisosBRecipes")
  ),
  Container2PisosBElections: dynamic(() =>
    import("./Container/Templates/Container2PisosBElections")
  ),
   Container3PisosAElections: dynamic(() =>
    import("./Container/Templates/Container3PisosAElections")
  ),
  Container2PisosRecipes: dynamic(() =>
    import("./Container/Templates/Container2PisosRecipes")
  ),
  Container1PisoColor: dynamic(() =>
    import("./Container/Templates/Container1PisoColor")
  ),
  ContainerGallery: dynamic(() => import('./Container/Templates/ContainerGallery')),
  ContainerList: dynamic(() => import('./Container/Templates/ContainerList')),
  ContainerShorts: dynamic(() => import('./Container/Templates/ContainerShorts')),
  ContainerApp1Notas: dynamic(() => import('./Container/Templates/ContainerApp1Notas')),
  ContainerApp3Notas: dynamic(() => import('./Container/Templates/ContainerApp3Notas')),
  ContainerDinamico: dynamic(() =>
    import("./Container/Templates/ContainerDinamico")),
  ContainerAniversaryDouble: dynamic(() => import('./Container/Templates/ContainerAniversaryDouble')),  
  Container2PisosSpecialFlip: dynamic(() => import('./Container/Templates/Container2PisosSpecialFlip')),
  
  //MUNDIAL

  ContainerMundial1: dynamic(() =>
    import("./Container/Templates/ContainerMundial1")
  ),

  ContainerMundial2: dynamic(() =>
    import("./Container/Templates/ContainerMundial2")
  ),
  ContainerMundial3: dynamic(() =>
    import("./Container/Templates/ContainerMundial3")
  ),
  //Nota
  BrandStudio: dynamic(() => import("./Nota/Templates/BrandStudio")),
  Half: dynamic(() => import("./Nota/Templates/Half")),
  HalfNoImage: dynamic(() => import("./Nota/Templates/HalfNoImage")),
  Multimedia: dynamic(() => import('./Nota/Templates/Multimedia')),
  OnexOne: dynamic(() => import("./Nota/Templates/OnexOne")),
  OnexOneList: dynamic(() => import("./Nota/Templates/OnexOneList")),
  OnexOneGrey: dynamic(() => import("./Nota/Templates/OnexOneGrey")),
  OnexOneNoImage: dynamic(() => import("./Nota/Templates/OnexOneNoImage")),
  OnexOneColumn: dynamic(() => import("./Nota/Templates/OnexOneColumn")),
  OnexTwo: dynamic(() => import("./Nota/Templates/OnexTwo")),
  OnexTwoSlide: dynamic(() => import("./Nota/Templates/OnexTwoSlide")),
  OneFull: dynamic(() => import("./Nota/Templates/OneFull")),
  TextoFotoCuadrado: dynamic(() => import("./Nota/Templates/TextoFotoCuadrado")),
  TwoxOneFoto: dynamic(() => import("./Nota/Templates/TwoxOneFoto")),
  TwoxOneNoImage: dynamic(() => import("./Nota/Templates/TwoxOneNoImage")),
  TwoxOneVisual: dynamic(() => import("./Nota/Templates/TwoxOneVisual")),
  TwoxTwoFoto: dynamic(() => import("./Nota/Templates/TwoxTwoFoto")),
  TwoxTwoFotoGrey: dynamic(() => import("./Nota/Templates/TwoxTwoFotoGrey")),
  TwoxTwoVisual: dynamic(() => import("./Nota/Templates/TwoxTwoVisual")),
  TwoxTwoVideo: dynamic(() => import("./Nota/Templates/TwoxTwoVideo")),
  TwoFull: dynamic(() => import("./Nota/Templates/TwoFull")),
  OnexOneRecipe: dynamic(() => import("./Nota/Templates/OnexOneRecipe")),
  OnexOneColor: dynamic(() => import("./Nota/Templates/OnexOneColor")),
  //Apertura
  AperturaFullFoto: dynamic(() => import("./Nota/Templates/AperturaFullFoto")),
  AperturaTextoFoto: dynamic(() =>
    import("./Nota/Templates/AperturaTextoFoto")
  ),
  AperturaTextoFotoHorizontal: dynamic(() =>
    import("./Nota/Templates/AperturaTextoFotoHorizontal")
  ),
  AperturaTitulo: dynamic(() => import("./Nota/Templates/AperturaTitulo")),
  AperturaAutos: dynamic(() => import("./Nota/Templates/AperturaAutos")),
  GallerySlide: dynamic(() => import("./Nota/Templates/GallerySlide")),
  
  //APP
  AppVisualSquare: dynamic(() => import("./Nota/Templates/AppVisualSquare")),
  AppVisualFull: dynamic(() => import("./Nota/Templates/AppVisualFull")),
  AppFotoVertical: dynamic(() => import("./Nota/Templates/AppFotoVertical")),
  AppVisualVertical: dynamic(() => import("./Nota/Templates/AppVisualVertical")),
  AppFotoSquare: dynamic(() => import("./Nota/Templates/AppFotoSquare")),
  AppVisualDiscovery: dynamic(() => import("./Nota/Templates/AppVisualDiscovery")),

  AperturaTextoFotoRecipe: dynamic(() =>
    import("./Nota/Templates/AperturaTextoFotoRecipe")
  ),
  AperturaTextoFotoBRecipe: dynamic(() =>
    import("./Nota/Templates/AperturaTextoFotoBRecipe")
  ),
  //80Años
  NewsAniversary: dynamic(() => import("./Nota/Templates/NewsAniversary")),
  NewsAniversarySmall: dynamic(() => import("./Nota/Templates/NewsAniversarySmall")),
  VideoVertical: dynamic(() => import("./Nota/Templates/VideoVertical")),
  //Landings
  AppAndKiosco: dynamic(() => import("./Landings/Templates/AppAndKiosco")),
  ExclusiveContent: dynamic(() =>
    import("./Landings/Templates/ExclusiveContent")
  ),
  ExitPopupOffer: dynamic(() => import("./Landings/Templates/ExitPopupOffer")),
  Discounts: dynamic(() => import("./Landings/Templates/Discounts")),
  SubscriptionForm: dynamic(() =>
    import("./Landings/Templates/SubscriptionForm")
  ),
  CardPromo365: dynamic(() => import("./Landings/Templates/CardPromo365")),
  Columnists: dynamic(() => import("./Landings/Templates/Columnists")),
  Faq: dynamic(() => import("./Landings/Templates/Faq")),
  MembershipBenefits: dynamic(() =>
    import("./Landings/Templates/MembershipBenefits")
  ),
  OpeningImage: dynamic(() => import("./Landings/Templates/OpeningImage")),
  Newsletters: dynamic(() => import("./Landings/Templates/Newsletters")),
  FaqsCardLanding: dynamic(() =>
    import("./Landings/Templates/FaqsCardLanding")
  ),
  InnovationAndServices: dynamic(() =>
    import("./Landings/Templates/InnovationAndServices")
  ),
  GamesLanding: dynamic(() => import("./Landings/Templates/GamesLanding")),
  ContactChannels: dynamic(() =>
    import("./Landings/Templates/ContactChannels")
  ),
  HeaderSubscribersLanding: dynamic(() =>
    import("./Landings/Templates/HeaderSubscribersLanding")
  ),
  FooterLanding: dynamic(() => import("./Landings/Templates/FooterLanding")),
  GiveawaySubscribers: dynamic(() =>
    import("./Landings/Templates/GiveawaySubscribers")
  ),
  InstructionLanding: dynamic(() =>
    import("./Landings/Templates/InstructionLanding")
  ),
  HeaderWithProducts: dynamic(() =>
    import("./Landings/Templates/HeaderWithProducts")
  ),
  HeaderBar: dynamic(() =>
    import("./Landings/Templates/HeaderBar")
  ),
  ShopsWithBenefits: dynamic(() =>
    import("./Landings/Templates/ShopsWithBenefits")
  ),
  SorteosSteps: dynamic(() =>
    import("./Landings/Templates/SorteosSteps")
  ),
  VideoLanding: dynamic(() => import("./Landings/Templates/VideoLanding")),
  MultiStepForm: dynamic(() => import("./Landings/Templates/MultiStepForm")),
};

export default templates;
